var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6344 5.20013C20.6344 2.36012 18.3233 0 15.4833 0C14.3766 0 13.3425 0.473555 12.5399 1.32584C11.7371 0.473555 10.703 0 9.59639 0C6.75638 0 4.44531 2.36012 4.44531 5.20013C4.44531 8.05667 6.54151 9.53125 8.96904 11.2394C9.97006 11.9436 11.0056 12.6723 12.0577 13.585L12.5391 14.0032L13.0213 13.5857C14.2106 12.5566 15.3417 11.7511 16.3392 11.0403C18.7387 9.33222 20.6344 7.98264 20.6344 5.20013ZM14.7475 7.40773H13.2757V8.87947H11.804V7.40773H10.3323V5.936H11.804V4.46426H13.2757V5.936H14.7475V7.40773Z",
    fill: "url(#paint0_linear_740_6168)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2095 6.73047C22.7083 6.73047 22.3208 13.7065 22.2913 13.8537C22.1418 14.8759 21.4217 16.389 20.2057 17.3001L17.0183 19.6143L16.1359 18.4358L19.3232 16.1223C20.5858 15.1757 21.1613 13.5593 19.5833 13.5593C18.17 13.5593 15.5283 15.1955 14.7451 15.8446C13.81 16.6197 13.2695 17.7714 13.2695 18.9861V25.1174H17.6847C17.6847 24.4109 18.0674 23.6407 18.656 22.9048C19.2742 22.0954 20.1573 21.2712 21.0697 20.4323C22.8063 18.7987 24.6068 17.1209 24.8423 15.4138C24.9821 14.267 25.0982 12.3002 25.0924 10.5472C25.086 8.58417 24.9197 6.7939 24.2095 6.73047Z",
    fill: "url(#paint1_linear_740_6168)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1691 15.7083C8.09393 14.2807 6.51927 13.5596 5.50377 13.5596C3.92578 13.5596 4.50123 15.1759 5.76383 16.1225L8.95117 18.4361L8.06871 19.6146L4.88138 17.3004C3.66523 16.3893 2.94516 14.8761 2.79568 13.854C2.7662 13.7067 2.37869 6.73071 0.877471 6.73071C0.0532987 6.8043 -0.0350056 9.20323 0.00919554 11.4991C0.0386793 13.1769 0.171086 14.8105 0.244624 15.414C0.480151 17.1212 2.28057 18.799 4.01722 20.4326C4.9297 21.2715 5.81269 22.0956 6.43087 22.9051C7.01951 23.641 7.40216 24.4112 7.40216 25.1176H11.8174V19.0157C11.8175 17.7156 11.2071 16.491 10.1691 15.7083Z",
    fill: "url(#paint2_linear_740_6168)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_6168",
    x1: 8.19095,
    y1: 7.91728,
    x2: 20.5181,
    y2: 7.91386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_740_6168",
    x1: 16.005,
    y1: 17.1263,
    x2: 25.0077,
    y2: 17.1249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_740_6168",
    x1: 2.73416,
    y1: 17.1265,
    x2: 11.7324,
    y2: 17.1251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.330bc8a0e67db54d6bf2bab14d2cdad7.svg";
export { ForwardRef as ReactComponent };